/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./types";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const addReferrer = /* GraphQL */ `mutation AddReferrer($referrer_id: ID!, $referrer_tags: [String]!) {
  addReferrer(referrer_id: $referrer_id, referrer_tags: $referrer_tags)
}
` as GeneratedMutation<
  APITypes.AddReferrerMutationVariables,
  APITypes.AddReferrerMutation
>;
export const joinReferralProgram = /* GraphQL */ `mutation JoinReferralProgram($investor_account_id: ID!) {
  joinReferralProgram(investor_account_id: $investor_account_id) {
    enrolled_at
    referral_count
    rewards_earned
    branch_link
    referrer_name
    referee_amount
    referee_completed_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.JoinReferralProgramMutationVariables,
  APITypes.JoinReferralProgramMutation
>;
export const accreditViaHelloSign = /* GraphQL */ `mutation AccreditViaHelloSign(
  $investor_account_id: ID!
  $name: String!
  $email: String!
) {
  accreditViaHelloSign(
    investor_account_id: $investor_account_id
    name: $name
    email: $email
  )
}
` as GeneratedMutation<
  APITypes.AccreditViaHelloSignMutationVariables,
  APITypes.AccreditViaHelloSignMutation
>;
export const accreditSelf = /* GraphQL */ `mutation AccreditSelf(
  $investor_account_id: ID!
  $is_accredited: Boolean!
  $reason_annual_income: Boolean
  $reason_net_worth: Boolean
  $reason_certification: Boolean
  $reason_employment: Boolean
) {
  accreditSelf(
    investor_account_id: $investor_account_id
    is_accredited: $is_accredited
    reason_annual_income: $reason_annual_income
    reason_net_worth: $reason_net_worth
    reason_certification: $reason_certification
    reason_employment: $reason_employment
  )
}
` as GeneratedMutation<
  APITypes.AccreditSelfMutationVariables,
  APITypes.AccreditSelfMutation
>;
export const addBankAccount = /* GraphQL */ `mutation AddBankAccount(
  $investor_account_id: ID!
  $public_token: ID!
  $bank_account_name: String!
  $bank_account_id: ID!
  $bank_account_type: String!
) {
  addBankAccount(
    investor_account_id: $investor_account_id
    public_token: $public_token
    bank_account_name: $bank_account_name
    bank_account_id: $bank_account_id
    bank_account_type: $bank_account_type
  ) {
    id
    name
    account_type
    account_number
    created_at
    default
    status
    ins_name
    plaid_ins_id
    plaid_reauth_required
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddBankAccountMutationVariables,
  APITypes.AddBankAccountMutation
>;
export const createPlaidLinkToken = /* GraphQL */ `mutation CreatePlaidLinkToken(
  $investor_account_id: ID!
  $bank_account_id: ID
  $android_package_name: String
) {
  createPlaidLinkToken(
    investor_account_id: $investor_account_id
    bank_account_id: $bank_account_id
    android_package_name: $android_package_name
  )
}
` as GeneratedMutation<
  APITypes.CreatePlaidLinkTokenMutationVariables,
  APITypes.CreatePlaidLinkTokenMutation
>;
export const addBankAccountViaPlaid = /* GraphQL */ `mutation AddBankAccountViaPlaid(
  $investor_account_id: ID!
  $public_token: ID!
  $bank_account_id: ID!
  $bank_account_name: String
  $bank_account_type: String
) {
  addBankAccountViaPlaid(
    investor_account_id: $investor_account_id
    public_token: $public_token
    bank_account_id: $bank_account_id
    bank_account_name: $bank_account_name
    bank_account_type: $bank_account_type
  ) {
    id
    name
    account_type
    account_number
    created_at
    default
    status
    ins_name
    plaid_ins_id
    plaid_reauth_required
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddBankAccountViaPlaidMutationVariables,
  APITypes.AddBankAccountViaPlaidMutation
>;
export const finishPlaidBankAccountVerify = /* GraphQL */ `mutation FinishPlaidBankAccountVerify(
  $investor_account_id: ID!
  $bank_account_id: ID!
) {
  finishPlaidBankAccountVerify(
    investor_account_id: $investor_account_id
    bank_account_id: $bank_account_id
  ) {
    id
    name
    account_type
    account_number
    created_at
    default
    status
    ins_name
    plaid_ins_id
    plaid_reauth_required
    __typename
  }
}
` as GeneratedMutation<
  APITypes.FinishPlaidBankAccountVerifyMutationVariables,
  APITypes.FinishPlaidBankAccountVerifyMutation
>;
export const removeBankAccount = /* GraphQL */ `mutation RemoveBankAccount($investor_account_id: ID!, $bank_account_id: ID!) {
  removeBankAccount(
    investor_account_id: $investor_account_id
    bank_account_id: $bank_account_id
  ) {
    id
    name
    account_type
    account_number
    created_at
    default
    status
    ins_name
    plaid_ins_id
    plaid_reauth_required
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemoveBankAccountMutationVariables,
  APITypes.RemoveBankAccountMutation
>;
export const setDefaultBankAccount = /* GraphQL */ `mutation SetDefaultBankAccount(
  $investor_account_id: ID!
  $bank_account_id: ID!
) {
  setDefaultBankAccount(
    investor_account_id: $investor_account_id
    bank_account_id: $bank_account_id
  ) {
    id
    name
    account_type
    account_number
    created_at
    default
    status
    ins_name
    plaid_ins_id
    plaid_reauth_required
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SetDefaultBankAccountMutationVariables,
  APITypes.SetDefaultBankAccountMutation
>;
export const deleteUnconfirmedUser = /* GraphQL */ `mutation DeleteUnconfirmedUser($email: String!) {
  deleteUnconfirmedUser(email: $email)
}
` as GeneratedMutation<
  APITypes.DeleteUnconfirmedUserMutationVariables,
  APITypes.DeleteUnconfirmedUserMutation
>;
export const deleteAutoInvestScheduleV2 = /* GraphQL */ `mutation DeleteAutoInvestScheduleV2(
  $investor_account_id: ID!
  $autoinvest_id: ID!
) {
  deleteAutoInvestScheduleV2(
    investor_account_id: $investor_account_id
    autoinvest_id: $autoinvest_id
  )
}
` as GeneratedMutation<
  APITypes.DeleteAutoInvestScheduleV2MutationVariables,
  APITypes.DeleteAutoInvestScheduleV2Mutation
>;
export const createAutoInvestScheduleV2 = /* GraphQL */ `mutation CreateAutoInvestScheduleV2(
  $investor_account_id: ID!
  $subscription_offer_id: ID!
  $amount: Int!
  $start_date: String
  $frequency: String!
  $interval: Int!
  $days_of_month: [Int!]
  $days_of_week: [Int!]
  $goal_id: ID
) {
  createAutoInvestScheduleV2(
    investor_account_id: $investor_account_id
    subscription_offer_id: $subscription_offer_id
    amount: $amount
    start_date: $start_date
    frequency: $frequency
    interval: $interval
    days_of_month: $days_of_month
    days_of_week: $days_of_week
    goal_id: $goal_id
  )
}
` as GeneratedMutation<
  APITypes.CreateAutoInvestScheduleV2MutationVariables,
  APITypes.CreateAutoInvestScheduleV2Mutation
>;
export const modifyAutoInvestSchedule = /* GraphQL */ `mutation ModifyAutoInvestSchedule(
  $investor_account_id: ID!
  $autoinvest_id: ID!
  $amount: Int!
  $start_date: String
  $frequency: String!
  $interval: Int!
  $days_of_month: [Int!]
  $days_of_week: [Int!]
) {
  modifyAutoInvestSchedule(
    investor_account_id: $investor_account_id
    autoinvest_id: $autoinvest_id
    amount: $amount
    start_date: $start_date
    frequency: $frequency
    interval: $interval
    days_of_month: $days_of_month
    days_of_week: $days_of_week
  )
}
` as GeneratedMutation<
  APITypes.ModifyAutoInvestScheduleMutationVariables,
  APITypes.ModifyAutoInvestScheduleMutation
>;
export const createReferral = /* GraphQL */ `mutation CreateReferral($referrer_id: ID!, $referee_id: ID!) {
  createReferral(referrer_id: $referrer_id, referee_id: $referee_id)
}
` as GeneratedMutation<
  APITypes.CreateReferralMutationVariables,
  APITypes.CreateReferralMutation
>;
export const createReferralCampaign = /* GraphQL */ `mutation CreateReferralCampaign(
  $referrer_amount: String!
  $referee_amount: String!
  $start_date: String!
  $end_date: String!
  $name: String!
) {
  createReferralCampaign(
    referrer_amount: $referrer_amount
    referee_amount: $referee_amount
    start_date: $start_date
    end_date: $end_date
    name: $name
  )
}
` as GeneratedMutation<
  APITypes.CreateReferralCampaignMutationVariables,
  APITypes.CreateReferralCampaignMutation
>;
export const updateReferralCampaign = /* GraphQL */ `mutation UpdateReferralCampaign($start_date: String!, $end_date: String!) {
  updateReferralCampaign(start_date: $start_date, end_date: $end_date)
}
` as GeneratedMutation<
  APITypes.UpdateReferralCampaignMutationVariables,
  APITypes.UpdateReferralCampaignMutation
>;
export const closeAccount = /* GraphQL */ `mutation CloseAccount($investor_account_id: ID!, $is_fraud: Boolean) {
  closeAccount(investor_account_id: $investor_account_id, is_fraud: $is_fraud)
}
` as GeneratedMutation<
  APITypes.CloseAccountMutationVariables,
  APITypes.CloseAccountMutation
>;
export const cancelTrade = /* GraphQL */ `mutation CancelTrade($trade_id: ID!, $reason: String!, $silently: Boolean) {
  cancelTrade(trade_id: $trade_id, reason: $reason, silently: $silently)
}
` as GeneratedMutation<
  APITypes.CancelTradeMutationVariables,
  APITypes.CancelTradeMutation
>;
export const cancelPurchaseTrade = /* GraphQL */ `mutation CancelPurchaseTrade(
  $trade_id: ID!
  $reason: String!
  $silently: Boolean
) {
  cancelPurchaseTrade(trade_id: $trade_id, reason: $reason, silently: $silently)
}
` as GeneratedMutation<
  APITypes.CancelPurchaseTradeMutationVariables,
  APITypes.CancelPurchaseTradeMutation
>;
export const cancelRedemptionTrade = /* GraphQL */ `mutation CancelRedemptionTrade($trade_id: ID!) {
  cancelRedemptionTrade(trade_id: $trade_id)
}
` as GeneratedMutation<
  APITypes.CancelRedemptionTradeMutationVariables,
  APITypes.CancelRedemptionTradeMutation
>;
export const unscheduleTrade = /* GraphQL */ `mutation UnscheduleTrade($trade_id: ID!) {
  unscheduleTrade(trade_id: $trade_id)
}
` as GeneratedMutation<
  APITypes.UnscheduleTradeMutationVariables,
  APITypes.UnscheduleTradeMutation
>;
export const declareDividend = /* GraphQL */ `mutation DeclareDividend($dividend_rate: DividendRateInput) {
  declareDividend(dividend_rate: $dividend_rate)
}
` as GeneratedMutation<
  APITypes.DeclareDividendMutationVariables,
  APITypes.DeclareDividendMutation
>;
export const fraudReviewTrade = /* GraphQL */ `mutation FraudReviewTrade($trade_id: ID!, $action: FraudReviewAction!) {
  fraudReviewTrade(trade_id: $trade_id, action: $action)
}
` as GeneratedMutation<
  APITypes.FraudReviewTradeMutationVariables,
  APITypes.FraudReviewTradeMutation
>;
export const invest = /* GraphQL */ `mutation Invest(
  $investor_account_id: ID!
  $subscription_offer_id: ID!
  $amount: Int!
  $signature_method: SignatureMethod
  $goal_id: ID
) {
  invest(
    investor_account_id: $investor_account_id
    subscription_offer_id: $subscription_offer_id
    amount: $amount
    signature_method: $signature_method
    goal_id: $goal_id
  )
}
` as GeneratedMutation<
  APITypes.InvestMutationVariables,
  APITypes.InvestMutation
>;
export const redeem = /* GraphQL */ `mutation Redeem(
  $investor_account_id: ID!
  $subscription_offer_id: ID!
  $amount: Int
  $redeem_all: Boolean
  $requested_date: String
  $revoke: Boolean
  $revoke_trade_id: ID
) {
  redeem(
    investor_account_id: $investor_account_id
    subscription_offer_id: $subscription_offer_id
    amount: $amount
    redeem_all: $redeem_all
    requested_date: $requested_date
    revoke: $revoke
    revoke_trade_id: $revoke_trade_id
  )
}
` as GeneratedMutation<
  APITypes.RedeemMutationVariables,
  APITypes.RedeemMutation
>;
export const createOrUpdateInvestorAccountApplication = /* GraphQL */ `mutation CreateOrUpdateInvestorAccountApplication(
  $investor_account: InvestorAccountApplicationInput!
) {
  createOrUpdateInvestorAccountApplication(
    investor_account: $investor_account
  ) {
    id
    user_id
    status
    claims_is_accredited
    email
    email2
    phone
    phone2
    address
    address2
    city
    state
    zip
    country
    domicile
    individual_details {
      account_type
      first_name
      last_name
      dob
      middle_name
      owners_accredited
      total_assets
      __typename
    }
    partner_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateInvestorAccountApplicationMutationVariables,
  APITypes.CreateOrUpdateInvestorAccountApplicationMutation
>;
export const approveInvestorAccountApplication = /* GraphQL */ `mutation ApproveInvestorAccountApplication(
  $application_id: String!
  $pricing_plan: String
  $accepted_tc: Boolean
) {
  approveInvestorAccountApplication(
    application_id: $application_id
    pricing_plan: $pricing_plan
    accepted_tc: $accepted_tc
  )
}
` as GeneratedMutation<
  APITypes.ApproveInvestorAccountApplicationMutationVariables,
  APITypes.ApproveInvestorAccountApplicationMutation
>;
export const approveInvestorAccountApplicationV2 = /* GraphQL */ `mutation ApproveInvestorAccountApplicationV2(
  $application_id: String!
  $pricing_plan: String
  $agreements: [AgreementCode!]!
) {
  approveInvestorAccountApplicationV2(
    application_id: $application_id
    pricing_plan: $pricing_plan
    agreements: $agreements
  )
}
` as GeneratedMutation<
  APITypes.ApproveInvestorAccountApplicationV2MutationVariables,
  APITypes.ApproveInvestorAccountApplicationV2Mutation
>;
export const acceptTermsAndConditions = /* GraphQL */ `mutation AcceptTermsAndConditions($investor_account_id: ID!) {
  acceptTermsAndConditions(investor_account_id: $investor_account_id)
}
` as GeneratedMutation<
  APITypes.AcceptTermsAndConditionsMutationVariables,
  APITypes.AcceptTermsAndConditionsMutation
>;
export const acceptTermsAndConditionsV2 = /* GraphQL */ `mutation AcceptTermsAndConditionsV2(
  $investor_account_id: ID!
  $agreements: [AgreementCode!]!
) {
  acceptTermsAndConditionsV2(
    investor_account_id: $investor_account_id
    agreements: $agreements
  )
}
` as GeneratedMutation<
  APITypes.AcceptTermsAndConditionsV2MutationVariables,
  APITypes.AcceptTermsAndConditionsV2Mutation
>;
export const configureInvestorAccountFixture = /* GraphQL */ `mutation ConfigureInvestorAccountFixture(
  $user_id: ID!
  $password: String!
  $fixture_config: InvestorAccountFixtureConfig!
) {
  configureInvestorAccountFixture(
    user_id: $user_id
    password: $password
    fixture_config: $fixture_config
  ) {
    new_user_id
    new_investor_account_id
    old_investor_account_id
    email_moved
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ConfigureInvestorAccountFixtureMutationVariables,
  APITypes.ConfigureInvestorAccountFixtureMutation
>;
export const updateInvestorAccount = /* GraphQL */ `mutation UpdateInvestorAccount(
  $investor_account_id: String!
  $investor_account: UpdateInvestorAccountInput!
) {
  updateInvestorAccount(
    investor_account_id: $investor_account_id
    investor_account: $investor_account
  )
}
` as GeneratedMutation<
  APITypes.UpdateInvestorAccountMutationVariables,
  APITypes.UpdateInvestorAccountMutation
>;
export const confirmPhoneNumberUpdate = /* GraphQL */ `mutation ConfirmPhoneNumberUpdate(
  $investor_account_id: String!
  $phone_number: String!
) {
  confirmPhoneNumberUpdate(
    investor_account_id: $investor_account_id
    phone_number: $phone_number
  )
}
` as GeneratedMutation<
  APITypes.ConfirmPhoneNumberUpdateMutationVariables,
  APITypes.ConfirmPhoneNumberUpdateMutation
>;
export const reopenInvestorAccount = /* GraphQL */ `mutation ReopenInvestorAccount($investor_account_id: String!) {
  reopenInvestorAccount(investor_account_id: $investor_account_id)
}
` as GeneratedMutation<
  APITypes.ReopenInvestorAccountMutationVariables,
  APITypes.ReopenInvestorAccountMutation
>;
export const setPricingPlan = /* GraphQL */ `mutation SetPricingPlan(
  $investor_account_id: ID!
  $pricing_plan: PricingPlan!
) {
  setPricingPlan(
    investor_account_id: $investor_account_id
    pricing_plan: $pricing_plan
  )
}
` as GeneratedMutation<
  APITypes.SetPricingPlanMutationVariables,
  APITypes.SetPricingPlanMutation
>;
export const submitKYCAMLManualReview = /* GraphQL */ `mutation SubmitKYCAMLManualReview(
  $investor_account_id: String!
  $manual_kyc_aml_review: ManualKYCAMLReviewInput!
) {
  submitKYCAMLManualReview(
    investor_account_id: $investor_account_id
    manual_kyc_aml_review: $manual_kyc_aml_review
  ) {
    photo_id_front_file {
      bucket
      key
      region
      download_url
      upload_url
      __typename
    }
    photo_id_back_file {
      bucket
      key
      region
      download_url
      upload_url
      __typename
    }
    submitted_at
    completed_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitKYCAMLManualReviewMutationVariables,
  APITypes.SubmitKYCAMLManualReviewMutation
>;
export const rejectKYCAMLManualReview = /* GraphQL */ `mutation RejectKYCAMLManualReview($investor_account_id: String!) {
  rejectKYCAMLManualReview(investor_account_id: $investor_account_id)
}
` as GeneratedMutation<
  APITypes.RejectKYCAMLManualReviewMutationVariables,
  APITypes.RejectKYCAMLManualReviewMutation
>;
export const releaseKYCAMLManualReview = /* GraphQL */ `mutation ReleaseKYCAMLManualReview($investor_account_id: String!) {
  releaseKYCAMLManualReview(investor_account_id: $investor_account_id)
}
` as GeneratedMutation<
  APITypes.ReleaseKYCAMLManualReviewMutationVariables,
  APITypes.ReleaseKYCAMLManualReviewMutation
>;
export const updateSuitabilityV2 = /* GraphQL */ `mutation UpdateSuitabilityV2(
  $investor_account_id: String!
  $survey: SurveyV2Input!
) {
  updateSuitabilityV2(
    investor_account_id: $investor_account_id
    survey: $survey
  ) {
    completed_at
    broker_dealer_assoc {
      updated_at
      value
      __typename
    }
    annual_income {
      updated_at
      value
      __typename
    }
    net_worth {
      updated_at
      value
      __typename
    }
    objective {
      updated_at
      value
      __typename
    }
    pct_liquid_securities {
      updated_at
      value
      __typename
    }
    pct_illiquid_securities {
      updated_at
      value
      __typename
    }
    time_horizon {
      updated_at
      value
      __typename
    }
    risk_profile {
      updated_at
      value
      __typename
    }
    experience {
      experience_stocks {
        updated_at
        value
        __typename
      }
      experience_bonds {
        updated_at
        value
        __typename
      }
      experience_re {
        updated_at
        value
        __typename
      }
      experience_alts {
        updated_at
        value
        __typename
      }
      migrated {
        updated_at
        value
        __typename
      }
      __typename
    }
    employment {
      employment_status
      occupation {
        updated_at
        value
        __typename
      }
      employer {
        updated_at
        value
        __typename
      }
      employer_address {
        updated_at
        value
        __typename
      }
      employer_address2 {
        updated_at
        value
        __typename
      }
      employer_city {
        updated_at
        value
        __typename
      }
      employer_state {
        updated_at
        value
        __typename
      }
      employer_zip {
        updated_at
        value
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSuitabilityV2MutationVariables,
  APITypes.UpdateSuitabilityV2Mutation
>;
export const createBdAccount = /* GraphQL */ `mutation CreateBdAccount(
  $investor_account_id: ID!
  $ssn: String!
  $dob: String!
) {
  createBdAccount(
    investor_account_id: $investor_account_id
    ssn: $ssn
    dob: $dob
  )
}
` as GeneratedMutation<
  APITypes.CreateBdAccountMutationVariables,
  APITypes.CreateBdAccountMutation
>;
export const storeSignatureFile = /* GraphQL */ `mutation StoreSignatureFile($signature: FileInput!) {
  storeSignatureFile(signature: $signature)
}
` as GeneratedMutation<
  APITypes.StoreSignatureFileMutationVariables,
  APITypes.StoreSignatureFileMutation
>;
export const storeHeadshot = /* GraphQL */ `mutation StoreHeadshot($photo: FileInput!) {
  storeHeadshot(photo: $photo) {
    bucket
    key
    region
    download_url
    upload_url
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StoreHeadshotMutationVariables,
  APITypes.StoreHeadshotMutation
>;
export const signAutoInvestDoc = /* GraphQL */ `mutation SignAutoInvestDoc(
  $investor_account_id: ID!
  $subscription_offer_id: ID!
) {
  signAutoInvestDoc(
    investor_account_id: $investor_account_id
    subscription_offer_id: $subscription_offer_id
  )
}
` as GeneratedMutation<
  APITypes.SignAutoInvestDocMutationVariables,
  APITypes.SignAutoInvestDocMutation
>;
export const updateProfile = /* GraphQL */ `mutation UpdateProfile($user_id: ID!, $profile: ProfileInput) {
  updateProfile(user_id: $user_id, profile: $profile)
}
` as GeneratedMutation<
  APITypes.UpdateProfileMutationVariables,
  APITypes.UpdateProfileMutation
>;
export const setInitialBranchData = /* GraphQL */ `mutation SetInitialBranchData($user_id: ID!, $initial_branch_data: String!) {
  setInitialBranchData(
    user_id: $user_id
    initial_branch_data: $initial_branch_data
  )
}
` as GeneratedMutation<
  APITypes.SetInitialBranchDataMutationVariables,
  APITypes.SetInitialBranchDataMutation
>;
export const triggerAutoInvests = /* GraphQL */ `mutation TriggerAutoInvests($trigger_date: String) {
  triggerAutoInvests(trigger_date: $trigger_date)
}
` as GeneratedMutation<
  APITypes.TriggerAutoInvestsMutationVariables,
  APITypes.TriggerAutoInvestsMutation
>;
export const issueDividends = /* GraphQL */ `mutation IssueDividends(
  $offering_id: ID!
  $period_start: String!
  $period_end: String!
  $record_date: String!
  $daily_dividend_rate: String
  $aggregate_dividend_amount: String
  $is_special: Boolean
) {
  issueDividends(
    offering_id: $offering_id
    period_start: $period_start
    period_end: $period_end
    record_date: $record_date
    daily_dividend_rate: $daily_dividend_rate
    aggregate_dividend_amount: $aggregate_dividend_amount
    is_special: $is_special
  )
}
` as GeneratedMutation<
  APITypes.IssueDividendsMutationVariables,
  APITypes.IssueDividendsMutation
>;
export const startDividendPayment = /* GraphQL */ `mutation StartDividendPayment(
  $investor_account_id: ID!
  $subscription_offer_id: String!
  $period: String!
) {
  startDividendPayment(
    investor_account_id: $investor_account_id
    subscription_offer_id: $subscription_offer_id
    period: $period
  )
}
` as GeneratedMutation<
  APITypes.StartDividendPaymentMutationVariables,
  APITypes.StartDividendPaymentMutation
>;
export const processClosing = /* GraphQL */ `mutation ProcessClosing(
  $offering_id: ID!
  $closing_at: String!
  $new_nav: String!
) {
  processClosing(
    offering_id: $offering_id
    closing_at: $closing_at
    new_nav: $new_nav
  )
}
` as GeneratedMutation<
  APITypes.ProcessClosingMutationVariables,
  APITypes.ProcessClosingMutation
>;
export const completeClosing = /* GraphQL */ `mutation CompleteClosing($offering_id: ID!, $closing_at: String!) {
  completeClosing(offering_id: $offering_id, closing_at: $closing_at)
}
` as GeneratedMutation<
  APITypes.CompleteClosingMutationVariables,
  APITypes.CompleteClosingMutation
>;
export const assessOfferingAMF = /* GraphQL */ `mutation AssessOfferingAMF($offering_id: ID!, $closing_at: String!) {
  assessOfferingAMF(offering_id: $offering_id, closing_at: $closing_at)
}
` as GeneratedMutation<
  APITypes.AssessOfferingAMFMutationVariables,
  APITypes.AssessOfferingAMFMutation
>;
export const completeAMFAssessment = /* GraphQL */ `mutation CompleteAMFAssessment($offering_id: ID!, $closing_at: String!) {
  completeAMFAssessment(offering_id: $offering_id, closing_at: $closing_at)
}
` as GeneratedMutation<
  APITypes.CompleteAMFAssessmentMutationVariables,
  APITypes.CompleteAMFAssessmentMutation
>;
export const queueSubscriptionAMFs = /* GraphQL */ `mutation QueueSubscriptionAMFs(
  $offering_id: ID!
  $closing_shares: String!
  $closing_nav: String!
  $closing_at: String!
  $period: DateIntervalInput
) {
  queueSubscriptionAMFs(
    offering_id: $offering_id
    closing_shares: $closing_shares
    closing_nav: $closing_nav
    closing_at: $closing_at
    period: $period
  )
}
` as GeneratedMutation<
  APITypes.QueueSubscriptionAMFsMutationVariables,
  APITypes.QueueSubscriptionAMFsMutation
>;
export const bdExportClosing = /* GraphQL */ `mutation BdExportClosing($subscription_offer_id: ID!, $closing_at: String!) {
  bdExportClosing(
    subscription_offer_id: $subscription_offer_id
    closing_at: $closing_at
  ) {
    subscription_offer_id
    closing_at
    file {
      bucket
      key
      region
      download_url
      upload_url
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BdExportClosingMutationVariables,
  APITypes.BdExportClosingMutation
>;
export const approveSuitability = /* GraphQL */ `mutation ApproveSuitability($trade_id: ID!) {
  approveSuitability(trade_id: $trade_id)
}
` as GeneratedMutation<
  APITypes.ApproveSuitabilityMutationVariables,
  APITypes.ApproveSuitabilityMutation
>;
export const snoozeSuitabilityApproval = /* GraphQL */ `mutation SnoozeSuitabilityApproval($trade_id: ID!) {
  snoozeSuitabilityApproval(trade_id: $trade_id)
}
` as GeneratedMutation<
  APITypes.SnoozeSuitabilityApprovalMutationVariables,
  APITypes.SnoozeSuitabilityApprovalMutation
>;
export const addGiftReward = /* GraphQL */ `mutation AddGiftReward(
  $investor_account_id: ID!
  $amount: Int!
  $note: String!
) {
  addGiftReward(
    investor_account_id: $investor_account_id
    amount: $amount
    note: $note
  )
}
` as GeneratedMutation<
  APITypes.AddGiftRewardMutationVariables,
  APITypes.AddGiftRewardMutation
>;
export const createGoal = /* GraphQL */ `mutation CreateGoal(
  $investor_account_id: ID!
  $goal_type: GoalType!
  $name: String!
  $target_date: String!
  $target_monthly_income: Int
  $target_value: Int
  $color: String
  $icon: String
  $allocate_shares: Boolean
) {
  createGoal(
    investor_account_id: $investor_account_id
    goal_type: $goal_type
    name: $name
    target_date: $target_date
    target_monthly_income: $target_monthly_income
    target_value: $target_value
    color: $color
    icon: $icon
    allocate_shares: $allocate_shares
  ) {
    investor_account_id
    goal_id
    goal_type
    name
    start_date
    target_date
    target_value
    target_monthly_income
    color
    icon
    current_value
    is_advised
    calculated_monthly_amount
    is_on_track
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGoalMutationVariables,
  APITypes.CreateGoalMutation
>;
export const resendEmailVerification = /* GraphQL */ `mutation ResendEmailVerification($investor_account_id: ID!) {
  resendEmailVerification(investor_account_id: $investor_account_id)
}
` as GeneratedMutation<
  APITypes.ResendEmailVerificationMutationVariables,
  APITypes.ResendEmailVerificationMutation
>;
export const updateGoal = /* GraphQL */ `mutation UpdateGoal(
  $investor_account_id: ID!
  $goal_id: ID!
  $goal_type: GoalType
  $name: String
  $start_date: String
  $target_date: String
  $target_monthly_income: Int
  $target_value: Int
  $color: String
  $icon: String
) {
  updateGoal(
    investor_account_id: $investor_account_id
    goal_id: $goal_id
    goal_type: $goal_type
    name: $name
    start_date: $start_date
    target_date: $target_date
    target_monthly_income: $target_monthly_income
    target_value: $target_value
    color: $color
    icon: $icon
  ) {
    investor_account_id
    goal_id
    goal_type
    name
    start_date
    target_date
    target_value
    target_monthly_income
    color
    icon
    current_value
    is_advised
    calculated_monthly_amount
    is_on_track
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGoalMutationVariables,
  APITypes.UpdateGoalMutation
>;
export const requestGoalAdvice = /* GraphQL */ `mutation RequestGoalAdvice($investor_account_id: ID!, $goal_id: ID!) {
  requestGoalAdvice(
    investor_account_id: $investor_account_id
    goal_id: $goal_id
  ) {
    investor_account_id
    goal_id
    goal_type
    name
    start_date
    target_date
    target_value
    target_monthly_income
    color
    icon
    current_value
    is_advised
    calculated_monthly_amount
    is_on_track
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RequestGoalAdviceMutationVariables,
  APITypes.RequestGoalAdviceMutation
>;
export const removeGoal = /* GraphQL */ `mutation RemoveGoal($investor_account_id: ID!, $goal_id: ID!) {
  removeGoal(investor_account_id: $investor_account_id, goal_id: $goal_id)
}
` as GeneratedMutation<
  APITypes.RemoveGoalMutationVariables,
  APITypes.RemoveGoalMutation
>;
export const waitlistAdd = /* GraphQL */ `mutation WaitlistAdd($email: String!, $referrer_code: String) {
  waitlistAdd(email: $email, referrer_code: $referrer_code) {
    email
    user_id
    investor_account_id
    referral_code
    has_access
    position
    __typename
  }
}
` as GeneratedMutation<
  APITypes.WaitlistAddMutationVariables,
  APITypes.WaitlistAddMutation
>;
export const waitlistLogSocial = /* GraphQL */ `mutation WaitlistLogSocial(
  $code: String
  $email: String
  $platform: SocialPlatform!
  $activity: SocialActivity!
  $activity_at: String
  $note: String
) {
  waitlistLogSocial(
    code: $code
    email: $email
    platform: $platform
    activity: $activity
    activity_at: $activity_at
    note: $note
  )
}
` as GeneratedMutation<
  APITypes.WaitlistLogSocialMutationVariables,
  APITypes.WaitlistLogSocialMutation
>;
export const waitlistGrantAccess = /* GraphQL */ `mutation WaitlistGrantAccess($code: String, $email: String) {
  waitlistGrantAccess(code: $code, email: $email)
}
` as GeneratedMutation<
  APITypes.WaitlistGrantAccessMutationVariables,
  APITypes.WaitlistGrantAccessMutation
>;
export const waitlistGrantAccessBatch = /* GraphQL */ `mutation WaitlistGrantAccessBatch($file: FileKeyBucketInput!) {
  waitlistGrantAccessBatch(file: $file)
}
` as GeneratedMutation<
  APITypes.WaitlistGrantAccessBatchMutationVariables,
  APITypes.WaitlistGrantAccessBatchMutation
>;
export const waitlistExportContacts = /* GraphQL */ `mutation WaitlistExportContacts(
  $access_filter: WaitListAccessFilter
  $limit: Int
) {
  waitlistExportContacts(access_filter: $access_filter, limit: $limit) {
    count
    url
    __typename
  }
}
` as GeneratedMutation<
  APITypes.WaitlistExportContactsMutationVariables,
  APITypes.WaitlistExportContactsMutation
>;
export const updateSubscriptionOffer = /* GraphQL */ `mutation UpdateSubscriptionOffer(
  $id: ID!
  $new_data: SubscriptionOfferInput!
  $old_data: SubscriptionOfferInput!
) {
  updateSubscriptionOffer(id: $id, new_data: $new_data, old_data: $old_data)
}
` as GeneratedMutation<
  APITypes.UpdateSubscriptionOfferMutationVariables,
  APITypes.UpdateSubscriptionOfferMutation
>;
export const upsertPartner = /* GraphQL */ `mutation UpsertPartner(
  $partner_id: ID!
  $name: String!
  $style: PartnerStyleInput!
) {
  upsertPartner(partner_id: $partner_id, name: $name, style: $style) {
    partner_id
    name
    style {
      primary_logo {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      secondary_logo {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      bg_color
      html
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpsertPartnerMutationVariables,
  APITypes.UpsertPartnerMutation
>;
export const dwollaUploadCustomerDocument = /* GraphQL */ `mutation DwollaUploadCustomerDocument(
  $investor_account_id: ID!
  $document: DwollaCustomerDocInput!
) {
  dwollaUploadCustomerDocument(
    investor_account_id: $investor_account_id
    document: $document
  )
}
` as GeneratedMutation<
  APITypes.DwollaUploadCustomerDocumentMutationVariables,
  APITypes.DwollaUploadCustomerDocumentMutation
>;
export const forceVerifyEmail = /* GraphQL */ `mutation ForceVerifyEmail($investor_account_id: ID!) {
  forceVerifyEmail(investor_account_id: $investor_account_id)
}
` as GeneratedMutation<
  APITypes.ForceVerifyEmailMutationVariables,
  APITypes.ForceVerifyEmailMutation
>;
